import 'alpinejs'

import Glide from '@glidejs/glide'

// var glide = new Glide('.glide', {
//   type: 'carousel',
//   autoplay: false,
//   hoverpause: false,
//   perView: 8,
//   breakpoints: {
// 		600: { perView: 2 },
//     1200: { perView: 4 }
// 	}
// })

// var glide2 = new Glide('.quick-links-wrapper', {
//   type: 'carousel',
//   autoplay: false,
//   hoverpause: false,
//   perView: 6,
//   breakpoints: {
// 		600: { perView: 2 },
//     1200: { perView: 3 }
// 	}
// })

// glide2.mount()

// glide.mount()

const options = { 
  type: 'slider',
  autoplay: false,
  hoverpause: false,
  perView: 8,
  breakpoints: {
		600: { perView: 2 },
    1200: { perView: 4 }
	}
};

const carousels = document.querySelectorAll(".glide");

Object.values(carousels).map(carousel => {
      new Glide(carousel, options).mount();
});


